import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 5px;
`;

export const TableWrapper = styled.div`
  overflow: auto;
  padding: 1px;
  cursor: move;
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  @media screen and (max-width: 600px) {
    border: 0;
  }
`;

export const THead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`;

export const TBody = styled.tbody`
  padding: 1px;
  box-shadow: 0 0 0 1px #ddd;
  border-radius: 4px;
  font-size: 14px;

  @media screen and (max-width: 600px) {
    padding: 0;
    box-shadow: none;
    border-radius: 0;
  }
`;

export const TR = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid #ddd;
  }

  @media screen and (max-width: 600px) {
    display: block;
    margin-bottom: 25px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }
`;

export const TH = styled.th`
  padding: 10px 25px;
  font-size: 14px;
  text-align: left;

  cursor: ${(p) => (p.sortable ? "pointer" : "default")};

  &:last-child {
    border-bottom: 0;
    text-align: right;
  }

  @media screen and (max-width: 600px) {
    padding: 10px 10px;
  }
`;

export const TD = styled.td`
  padding: 15px 25px;

  @media screen and (max-width: 600px) {
    padding: 10px 10px;
    border-bottom: 1px solid #ddd;
    display: block;
    text-align: right;

    &:before {
      content: attr(data-label);
      float: left;
      font-weight: bold;
    }

    &:last-child {
      border-bottom: 0;
    }
  }

  text-align: left;

  &:last-child {
    text-align: right;
  }
`;

export const Icon = styled.em`
  margin-right: 6px;
  color: #1f78ae;
`;

export const Text = styled.span`
  color: #1f78ae;
  font-weight: bold;
`;

export const StyledIcon = styled.div`
  color: ${(p) => (p.selected ? p.theme.colors.info : "lightgrey")};
  margin-left: 5px;
  cursor: pointer;

  transition: all 150ms ease;
  &:hover {
    color: ${(p) => p.theme.colors.info};
  }
`;

export const Search = styled.input`
  background-color: transparent;
  border: none;
  border-bottom: 1px solid black;
  outline: none;

  &:focus {
    border: none;
    border-bottom: 1px solid ${(p) => p.theme.colors.info};
    outline: none;
  }
  &:active {
    border-bottom: 1px solid ${(p) => p.theme.colors.info};
  }
`;

export const NoDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 75px;
  padding-bottom: 75px;
  font-family: ${(p) => p.theme.fonts.primary};
  font-size: 1.2rem;
  border: 1px solid ${(p) => p.theme.colors.border};
  border-radius: 4px;
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FilterBadge = styled.div`
  background-color: #ccc;
  border-radius: 5px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
  padding-right: 10px;
  font-size: 0.7rem;
  height: 27px;
  margin-left: 10px;
`;

export const FilterIcon = styled.div`
  margin-right: 3px;
  cursor: pointer;

  &:hover {
    color: ${(p) => p.theme.colors.danger};
  }
`;

export const TopBar = styled.div`
  margin-bottom: 10px;
  padding-bottom: 20px;
  display: flex;
  align-items: flex-end;
`;

export const PageSizeWrapper = styled.ul`
  margin: 0px;
  display: flex;
  padding: 0px;
  align-items: center;
  list-style-type: none;
`;

export const Page = styled.li`
  font-size: 0.9rem;
  font-weight: ${(p) => (p.selected ? "bold" : "normal")};
  border-right: 1px solid ${(p) => p.theme.colors.border};
  padding: 0px 10px;
  cursor: pointer;
  text-decoration: none;

  &:last-child {
    border-right: none;
  }

  &:hover {
    border-bottom: 1px solid ${(p) => p.theme.colors.secondary};
  }
`;

export const Reload = styled.div`
  margin-left: ${(p) => (p.shouldDisplayMoreDropdown ? "20px" : "auto")};
  font-size: 0.9rem;
  &:hover {
    border-bottom: 1px solid ${(p) => p.theme.colors.secondary};
  }
  cursor: pointer;
  margin-right: 10px;
`;

export const MoreWrapper = styled.div`
  display: flex;
  margin-left: auto;
  align-items: center;
`;

export const MultiSelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0%;
  min-width: ${(p) => (p.shouldRenderSelectAllCheckbox ? "200px" : "0px")};

  & TH {
    padding: 0 25px;
  }
`;
